module.exports = __webpack_public_path__ + "static/media/medication.86cb7804.svg";